import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {Message,Checkbox} from 'element-ui'
import http from './utils/http'
import tool from './utils/tool'
import api from './api'
import base64 from 'base64'
import md5 from 'md5'
import qs from 'qs'
import '@/assets/css/main.scss'
import '@/assets/fonts/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$tool = tool
Vue.prototype.$api = api
Vue.prototype.$md5 = md5
Vue.prototype.$qs = qs
Vue.prototype.$base64 = base64

Vue.use(Checkbox);
Vue.prototype.$message = Message

window.$vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
